import React from 'react';
import PropTypes from 'prop-types';
import './SettingsTab.scss';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from 'react-bootstrap';
import RiskConfiguration from '../../Common/RiskSettings/RiskConfiguration/RiskConfiguration';


const SettingsTab = ({ t }) => {
  return (
    <>
      {/* <Tabs
        defaultActiveKey="Risk-score-weight-tab"
        id="fill-tab-example"
        className="All_tab-viewbox"
      >
        <Tab eventKey="Risk-score-weight-tab" title="Configurations"> */}
         
            <RiskConfiguration />
          
        
        {/* </Tab>

      </Tabs> */}

    </>
  );
};
export default withTranslation()(SettingsTab);